import { render, staticRenderFns } from "./VerifactuMessageModal.vue?vue&type=template&id=f116120a&"
import script from "./VerifactuMessageModal.vue?vue&type=script&lang=js&"
export * from "./VerifactuMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports